import { useRequestURL, useRoute, useRuntimeConfig } from '#imports'
import { ref, watchEffect } from 'vue'

import { useAuthStore } from '@backmarket/nuxt-layer-oauth/useAuthStore'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import { buildStudentVerificationUrl } from './StudentDiscountCTA.utils'

export function useStudentVerificationUrl() {
  const url = ref<ReturnType<typeof buildStudentVerificationUrl>>()
  const error = ref()

  const marketplace = useMarketplace()
  const authStore = useAuthStore()

  const { SHEER_ID_STUDENT_DISCOUNT_URL } = useRuntimeConfig().public

  const route = useRoute()

  const logger = useLogger()

  const ssrFriendlyUrl = useRequestURL()

  // Note: we use watchEffect to make sure the code is reactive and re-run on hydration.
  // need to investigate why the authStore doesn't work server-side
  watchEffect(() => {
    try {
      url.value = buildStudentVerificationUrl({
        authenticated: authStore.authenticated,
        market: marketplace.market,
        encryptedUserId: authStore.encryptedUserId,
        currentRoute: route,
        sheerIdUrl: SHEER_ID_STUDENT_DISCOUNT_URL,
        originUrl: ssrFriendlyUrl.origin,
      })
    } catch (err) {
      logger.error('[CONTENT] error when building student verification url', {
        error: err as Error,
      })
      error.value = err
    }
  })

  return { url, error }
}
